<!-- TODO: Since this is a standalone parent component can we refactor pest service insights to use routing?-->
<ng-container *ngIf="isPestDivision; else nonPestServiceInsights">
  <app-pest-service-insights></app-pest-service-insights>
</ng-container>

<ng-template #nonPestServiceInsights>
    <div
      id="service-insights-container"
      class="flex flex-col bg-light-blue ml-neptune-sidebar min-h-[70%] mb-neptune-bar"
    >
      <!-- Header : KPIs for filter selection, Download Spreadsheet button-->
      <section id="service-insights-header" class="flex-col pt-6 mx-8 gap-6">
        <div
          id="service-insights-download-button"
          class="flex w-full justify-end"
        >
          <download-spreadsheet-button id="spreadsheet-download-button">
          </download-spreadsheet-button>
        </div>

        <!-- Service Insights KPI Cards -->
        <section
          id="service-kpi-cards"
          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 my-6"
        >
          <service-kpi-card
            *ngFor="let kpi of serviceKpiCards; trackBy: trackByKpiKey"
            [title]="kpi.title"
            [value]="kpi.value"
            [icon]="kpi.icon"
            [loading]="loading"
          >
          </service-kpi-card>
        </section>
      </section>

      <!-- Body: Stacked bar graph, Metrics, Service Insights table, Location Insights table-->
      <section id="service-insights-body" class="flex-col gap-6 mx-8">

        <!-- Stacked bar graph showing calls distribution -->
        <div class="pt-1 bg-white">
          <service-call-distribution-chart
            class="p-4"
            [items]="serviceCallDistributionItems"
            [loading]="loading">
          </service-call-distribution-chart>
        </div>

        <div class="flex flex-col gap-6 p-6 bg-white mb-neptune-bar">
          <section
            id="service-insights-metrics"
            class="w-full flex flex-col gap-6"
          >
            <div *ngIf="!loading" class="flex items-center gap-2">
              <input
                id="service-metric-cards-add-all-checkbox"
                class="w-4 h-4 accent-blue"
                test-id="service-metric-cards-add-all-checkbox"
                #addServiceMetric
                type="checkbox"
                [checked]="allChecked"
                (click)="_onAllCheckedChange(addServiceMetric.checked)"
              />
              <label for="service-metric-cards-add-all-checkbox">Add All</label>
            </div>

            <section  class="service-metrics-sections flex flex-col lg:flex-row gap-6">
              <!-- Service Metrics | Calls -->
              <section id="service-metric-calls" class="flex flex-col gap-4 flex-[3]">
                <span class="text-neptune-color-primary-700 text-xl">
                  Service Metrics |
                  <span class="text-neptune-neutral" id="subtitle"> Calls</span>
                </span>
                <div
                  id="service-metric-cards"
                  class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6"
                >
                  <ng-container *ngFor="let metric of metrics; let i = index">
                    <service-metric-card
                      [metricTitle]="metric.title"
                      [metricKey]="metric.key"
                      [serviceMetricType]="ServiceMetricTypes.Calls"
                      [isEnableCheckBox]="true"
                      [summaryMetric]="getSummaryMetric(metric.key)"
                       [trainingBreakdown]="metric.key === SICallTypes.TrainingSessions ? metricCountsSummary?.trainingBreakdown : undefined"
                    >
                    </service-metric-card>
                  </ng-container>
                </div>
              </section>

              <!-- Divider between Calls and Observation sections -->
              <div class="hidden lg:block w-px bg-neptune-border-subtle"></div>

              <!-- Service Metrics | Observation -->
              <section id="service-metric-observations" class="flex flex-col gap-4 flex-1">
                <span class="text-neptune-color-primary-700 text-xl">
                  Service Metrics |
                  <span class="text-neptune-neutral" id="subtitle"> Observations</span>
                </span>
                <div id="service-observation-cards" class="grid grid-cols-1 gap-6">
                  <ng-container *ngFor="let metric of observationMetrics; let i = index">
                    <service-metric-card
                      [metricTitle]="metric.title"
                      [metricKey]="metric.key"
                      [serviceMetricType]="ServiceMetricTypes.Observations"
                      [isEnableCheckBox]="metric.isEnableCheckBox"
                      [summaryMetric]="getSummaryMetric(metric.key)"
                    >
                    </service-metric-card>
                  </ng-container>
                </div>
              </section>
            </section>
          </section>

          <service-insights-table></service-insights-table>

          <location-insights-table></location-insights-table>
        </div>
      </section>
    </div>
</ng-template>
